import { useNavigate } from "react-router-dom"
import { useRecoilValue, useSetRecoilState, useRecoilState } from "recoil"
import { questionData } from "../state/questions"
import { showAnswerData } from "../state/showAnswer"
import { answerModeData } from "../state/answerMode"
import { useDeckBase } from "./useDeck"
import { useRound } from "./useRound"
import { useRoundIndex } from "./useRoundIndex"
import { useEffect } from "react"

export const useNavHandler = () => {
	const navigate = useNavigate()
	const base = useDeckBase()
	const questions = useRecoilValue(questionData)
	const [answerMode, setAnswerMode] = useRecoilState(answerModeData)
	const setShowAnswer = useSetRecoilState(showAnswerData)
	const round = useRound()
	const index = useRoundIndex()

	useEffect(() => {
		if (round === undefined || index === undefined) return

		const handleKeyDown = (e: KeyboardEvent) => {
			const r = questions[round - 1]
			if (e.key === "ArrowRight") {
				if (index === "summary") {
					setAnswerMode(false)
					questions.length > round && navigate(`${base}/${round + 1}/1`)
				} else if (r.length > index) {
					navigate(`${base}/${round}/${index + 1}`)
				} else {
					navigate(`${base}/${round}/summary`)
				}
			} else if (e.key === "ArrowLeft") {
				if (index === "summary") {
					navigate(`${base}/${round}/${r.length}`)
				} else if (index > 1) {
					navigate(`${base}/${round}/${index - 1}`)
				} else if (round > 1) {
					navigate(`${base}/${round - 1}/summary`)
				}
			}
		}
		document.addEventListener("keydown", handleKeyDown)
		return () => document.removeEventListener("keydown", handleKeyDown)
	}, [navigate, base, round, index, questions, setAnswerMode])

	useEffect(() => {
		setShowAnswer(false)
	}, [round, index, answerMode, setShowAnswer])
}
